import { cva } from "class-variance-authority";
import { useContext } from "react";

import { BreadcrumbsContext } from "./BreadcrumbsContext";

export const breadcrumbContainerClass = "space-y-1.5";
export const breadcrumbTitleClass =
  "text-xs font-semibold uppercase tracking-ui-label text-neutral-600";
export const breadcrumbTrailClass =
  "flex items-center gap-2 text-md text-neutral-600";
export const breadcrumbSeparatorClass = "h-3.5 w-3.5 text-neutral-600";

export const breadcrumbItemClass = cva(
  "text-sm transition-colors duration-normal ease-standard",
  {
    variants: {
      isActive: {
        true: "text-neutral-950",
        false: "text-neutral-400",
      },
      interactive: {
        true: "-mx-1 rounded-lg px-1 cursor-pointer hover:text-neutral-950 focus-visible:text-neutral-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/25 focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        false: "cursor-default",
      },
    },
    compoundVariants: [
      {
        isActive: true,
        interactive: true,
        className: "cursor-default",
      },
    ],
    defaultVariants: {
      isActive: false,
      interactive: false,
    },
  }
);

export const useBreadcrumbs = () => {
  const context = useContext(BreadcrumbsContext);
  if (context === undefined) {
    throw new Error("useBreadcrumbs must be used within a BreadcrumbsProvider");
  }
  return context;
};
